var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "inline-input", class: { active: _vm.isEditing } },
    [
      !_vm.isEditing
        ? _c(
            "span",
            { staticClass: "input-display", on: { click: _vm.startEdit } },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.displayValue || _vm.placeholder) +
                  "\n    "
              ),
            ]
          )
        : _c("a-input", {
            ref: "input",
            staticClass: "input-field",
            attrs: { type: _vm.type },
            on: {
              blur: _vm.finishEdit,
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.finishEdit.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  ) {
                    return null
                  }
                  return _vm.cancelEdit.apply(null, arguments)
                },
              ],
            },
            model: {
              value: _vm.localValue,
              callback: function ($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }